/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillEnumItem } from './BillEnumItem';
import {
    BillEnumItemFromJSON,
    BillEnumItemFromJSONTyped,
    BillEnumItemToJSON,
    BillEnumItemToJSONTyped,
} from './BillEnumItem';

/**
 * 
 * @export
 * @interface ResponseListBillEnumItem
 */
export interface ResponseListBillEnumItem {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListBillEnumItem
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListBillEnumItem
     */
    message?: string;
    /**
     * 
     * @type {Array<BillEnumItem>}
     * @memberof ResponseListBillEnumItem
     */
    data?: Array<BillEnumItem>;
}

/**
 * Check if a given object implements the ResponseListBillEnumItem interface.
 */
export function instanceOfResponseListBillEnumItem(value: object): value is ResponseListBillEnumItem {
    return true;
}

export function ResponseListBillEnumItemFromJSON(json: any): ResponseListBillEnumItem {
    return ResponseListBillEnumItemFromJSONTyped(json, false);
}

export function ResponseListBillEnumItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListBillEnumItem {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(BillEnumItemFromJSON)),
    };
}

export function ResponseListBillEnumItemToJSON(json: any): ResponseListBillEnumItem {
    return ResponseListBillEnumItemToJSONTyped(json, false);
}

export function ResponseListBillEnumItemToJSONTyped(value?: ResponseListBillEnumItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(BillEnumItemToJSON)),
    };
}

